import api from "api";

export function postUserLog(logData) {
  return api.post("/user/log", logData);
}
